import { useMemo } from "react";
import { useRouter } from "next/router";
import withMiddlewares from "@/middlewares/withMiddlewares";
import NoContentMessage from "@/components/NoContentMessage";
import PaletteMetaTags, { tags } from "@/components/MetaTags/PaletteMetaTags";
import { usePaletteQuery } from "@/hooks";
import { PALETTE } from "@/apollo/queries/palette";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import PaletteGrid from "@/components/PaletteGrid";
import styles from "@/styles/PalettePage.module.scss";

export default function PalettePage() {
  const router = useRouter();
  const paletteId = useMemo(() => parseInt(router.query.id, 10), [
    router?.query?.id,
  ]);
  const {
    data: { palette },
  } = usePaletteQuery({
    variables: { id: paletteId, offset: 0, limit: GRID_PAGE_LIMIT },
    fetchPolicy: "cache-first",
  });

  return (
    <>
      <PaletteMetaTags id={paletteId} title={palette.header || palette.name} />
      <div className={styles.container}>
        <PaletteGrid
          id={paletteId}
          noContent={<NoContentMessage message="該当の作品がありません" />}
        />
      </div>
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({ req, query }, { serverProps, error, apolloClient }) => {
    const id = parseInt(query.id, 10);
    const {
      data: { palette },
    } = await apolloClient.query({
      query: PALETTE,
      variables: { id, offset: 0, limit: GRID_PAGE_LIMIT },
    });

    if (!palette) {
      return { notFound: true };
    }

    const title = palette.header || palette.name;
    const metatags = tags(id, title);
    return {
      props: {
        ...serverProps,
        error,
        metatags,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
